import _ from "lodash";
import { useAuth } from "react-oidc-context";
import { useCreateReportMutation } from "../../../../services/clientreports";
import { CreateClientReportForm } from "../types";
import { ClientReportType } from "../../../../types/ClientReportType";

export type CreateReportOptions = {
    createReport: (form: CreateClientReportForm) => Promise<ClientReportType>,
    createReportResult: any,
    isCreating: boolean,
    isAllowedToAssignAuthor: boolean,
    isAllowedToSetDeadlineDate: boolean,
    isAllowedToSetEstimatedMinutes: boolean
};

export const allowAssignAuthorRoles = ["sys_admin_access", "report_assign_author", "report_assign_self"];
export const allowSetDeadlineDateRoles = ["sys_admin_access", "report_admin", "report_adjust_deadline"];
export const allowSetEstimatedMinutesRoles = ["sys_admin_access", "report_admin"];
export const useCreateReport = (masterAccountId: string) : CreateReportOptions => {
    const auth = useAuth();
    const { roles } = auth.user!.profile;
    const [create, { isLoading, ... rest }] = useCreateReportMutation();
    const isAllowedToAssignAuthor = _.some(roles, (item: string) => allowAssignAuthorRoles.includes(item));
    const isAllowedToSetDeadlineDate = _.some(roles, (item: string) => allowSetDeadlineDateRoles.includes(item));
    const isAllowedToSetEstimatedMinutes = _.some(roles, (item: string) => allowSetEstimatedMinutesRoles.includes(item));

    const handleCreate = (data: CreateClientReportForm) : Promise<ClientReportType> => new Promise<ClientReportType>((resolve, reject) => {
        return create({ data, masterAccountId }).unwrap().then(
            (r: ClientReportType) => resolve(r),
            (e: any) => reject(e)
        );
    });

    return {
        createReport: handleCreate,
        createReportResult: { isLoading, ...rest },
        isCreating: isLoading,
        isAllowedToAssignAuthor,
        isAllowedToSetDeadlineDate,
        isAllowedToSetEstimatedMinutes    
    };
};